import React from "react";
import Img from "./basic/Img";

export default function Side({ side, illusts, ...props }) {
    const showModal = () => {
        const modalMain = document.getElementById("modal-main");
        document
            .getElementById("modal-wrap")
            .style.setProperty("display", "flex");
        document
            .getElementById("timetable")
            .style.setProperty("display", "flex");
        document
            .getElementById("modal-contents")
            .style.setProperty("display", "none");
        modalMain.style.setProperty("overflow-y", "hidden");
        modalMain.style.setProperty("box-shadow", "none");
        modalMain.classList.add("modal-timetable");
        document
            .getElementById("modal-main")
            .style.setProperty("box-shadow", "none");
        document
            .getElementById("modal-main-bg")
            .style.setProperty("background", "#82ebff");
        document
            .getElementById("modal-main-bg")
            .style.setProperty("opacity", "1");
        document.body.style.setProperty("overflow", "hidden");
    };
    return (
        <div className={side}>
            <div className={`${side}-main`}>
                {illusts.map((i, idx) =>
                    !i.link ? (
                        <div className="bg_illust-wrap">
                            <Img fileName={i.fn} key={idx} />
                        </div>
                    ) : (
                        <div className="bg_illust-wrap">
                            <a
                                rel="noopener noreferrer"
                                onClick={() => {
                                    showModal();
                                    gtag("event", "click", {
                                        event_category: "modal",
                                        event_label: "timetable",
                                    });
                                }}
                            >
                                <Img fileName={i.fn} key={idx} />
                            </a>
                        </div>
                    )
                )}
            </div>
            <div className={`${side}-sub`}></div>
        </div>
    );
}
